module.exports = __webpack_public_path__ + "static/media/modely@2x.87a614d3.png";